var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signPriview"},[_c('ul',{staticClass:"list"},_vm._l((_vm.fileList),function(item,index){return _c('li',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":item,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }